import { useBackButton } from '@/telegram';

export type LobbyMode = 'hotseat' | 'multi';

export interface ModePickerProps {
  onSelect: (mode: LobbyMode) => void;
  onProfile: () => void;
  /** Почему предыдущая комната не открылась. Текст приходит от сервера как есть. */
  notice?: string;
}

/**
 * Развилка первым шагом лобби: hotseat (один телефон по кругу) или multi
 * (у каждого свой). В макете этого экрана нет — design-spec.md рисует только
 * hotseat-состав, а лобби с него и начинается: дальше сценарии расходятся
 * (создание комнаты для multi устроено совсем иначе, чем заявка на всех
 * игроков сразу для hotseat), так что выбор режима не может ждать.
 */
export function ModePicker({ onSelect, onProfile, notice }: ModePickerProps) {
  useBackButton(null); // отсюда возвращаться некуда — гейт пройден насовсем

  return (
    <div
      className="flex min-h-screen flex-col justify-center gap-3 bg-ground px-5 text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)', paddingBottom: 'var(--clown-safe-bottom)' }}
    >
      <h1 className="mb-3 font-display text-task">КАК ИГРАЕМ</h1>

      {notice && (
        <p className="mb-1 text-base text-acc">
          В прошлую комнату не пустили: {notice}
        </p>
      )}

      <button
        type="button"
        onClick={() => onSelect('hotseat')}
        className="min-h-tap appearance-none rounded-none border-2 border-line bg-panel p-4 text-left"
      >
        <div className="font-display text-row">ОДИН ТЕЛЕФОН</div>
        <div className="mt-1 text-lead text-dim">Передаём по кругу</div>
      </button>

      <button
        type="button"
        onClick={() => onSelect('multi')}
        className="min-h-tap appearance-none rounded-none border-2 border-line bg-panel p-4 text-left"
      >
        <div className="font-display text-row">У КАЖДОГО СВОЙ</div>
        <div className="mt-1 text-lead text-dim">Каждый подключается со своего телефона</div>
      </button>

      {/*
        Профиль тише двух режимов намеренно: сюда заходят раз в жизни, а игру
        начинают каждый вечер. Тап-зона всё равно полная.
      */}
      <button
        type="button"
        onClick={onProfile}
        className="mt-3 min-h-tap appearance-none rounded-none px-4 text-left text-meta uppercase text-mute"
      >
        Профиль и история
      </button>
    </div>
  );
}
